const storageUtils = {
  /**
   * 存储方式
   */
  storageObj: window.localStorage,
  /**
   * 保存
   * @param namespace
   * @param key
   * @param value
   */
  setItem: function (namespace, key, value) {
    if (this.storageObj) {
      this.storageObj.setItem(namespace + '_' + key, JSON.stringify(value))
    }
  },
  /**
   * 获取
   * @param namespace
   * @param key
   * @returns {any}
   */
  getItem: function (namespace, key) {
    if (this.storageObj) {
      return JSON.parse(this.storageObj.getItem(namespace + '_' + key))
    }
  },
  /**
   * 删除
   * @param namespace
   * @param key
   */
  removeItem: function (namespace, key) {
    if (this.storageObj) {
      this.storageObj.removeItem(namespace + '_' + key)
    }
  },
  /**
   * 清空
   * @param namespace
   */
  clear: function (namespace) {
    if (this.storageObj) {
      for (let index = this.storageObj.length; index >= 0; index--) {
        let key = this.storageObj.key(index)
        if (key && key.startsWith(namespace + '_')) {
          this.storageObj.removeItem(key)
        }
      }
    }
  },
  /**
   * 清空全部
   */
  clearAll: function () {
    if (this.storageObj) {
      this.storageObj.clear()
    }
  }
}

export default storageUtils
